(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );


  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  (() => {
    const slotSelector = '[data-dlm-delivery-date-slot]';
    const dateTextPattern = /(wunsch\s*lieferdatum|wunsch.?liefer|lieferdatum|delivery\s*date)/i;
    const appHintPattern = /(oddm|appjetty|delivery[-_ ]?date|date[-_ ]?(picker|calendar))/i;
    const controlSelector =
      'input:not([type="hidden"]):not([type="submit"]), select, textarea, [role="combobox"]';
    let scheduled = false;

    const classText = (element) => {
      if (!element) return '';
      const value = element.className;
      return typeof value === 'string' ? value : '';
    };

    const elementIdentity = (element) =>
      element ? (element.id || '') + ' ' + classText(element) + ' ' + (element.textContent || '') : '';

    const hasDateControl = (element) => Boolean(element && element.querySelector(controlSelector));

    const hasDateIdentity = (element) => {
      if (!element) return false;
      const identity = elementIdentity(element);
      return appHintPattern.test(identity) || dateTextPattern.test(identity);
    };

    const containsCheckout = (element) =>
      Boolean(
        element &&
        (
          element.matches('#checkout, .cart__ctas, .cart__dynamic-checkout-buttons, [name="checkout"]') ||
          element.querySelector('#checkout, .cart__ctas, .cart__dynamic-checkout-buttons, [name="checkout"]')
        )
      );

    const isBroadThemeContainer = (element) =>
      Boolean(
        element &&
        element.matches(
          'html, body, main, .page-width, .cart__footer, .cart__blocks, .cart__contents, cart-items, #main-cart-footer, .cart__ctas, .cart__dynamic-checkout-buttons'
        )
      );

    const promoteToCompleteContainer = (element) => {
      let current = element;
      let best = null;

      for (let depth = 0; current && depth < 6; depth += 1) {
        if (isBroadThemeContainer(current) || containsCheckout(current)) break;

        if (hasDateControl(current) && hasDateIdentity(current)) {
          best = current;
        }

        current = current.parentElement;
      }

      return best;
    };

    const findByLabelText = (slot) => {
      const candidates = Array.from(
        document.querySelectorAll('label, h1, h2, h3, h4, p, span, div')
      )
        .filter((element) => {
          if (slot.contains(element)) return false;
          const value = (element.textContent || '').trim().replace(/\s+/g, ' ');
          return value.length > 0 && value.length <= 140 && dateTextPattern.test(value);
        })
        .sort(
          (a, b) =>
            (a.textContent || '').trim().length - (b.textContent || '').trim().length
        );

      for (const label of candidates) {
        const widget = promoteToCompleteContainer(label.parentElement);
        if (widget) {
          label.classList.add('dlm-delivery-date-label');
          return widget;
        }
      }

      return null;
    };

    const findByAppMarkers = (slot) => {
      const selectors = [
        '[id*="oddm" i]',
        '[class*="oddm" i]',
        '[id*="appjetty" i]',
        '[class*="appjetty" i]',
        '[id*="delivery-date" i]',
        '[class*="delivery-date" i]',
        '[id*="delivery_date" i]',
        '[class*="delivery_date" i]',
        '[id*="date-picker" i]',
        '[class*="date-picker" i]',
        '[id*="date-calendar" i]',
        '[class*="date-calendar" i]'
      ];

      for (const selector of selectors) {
        const elements = document.querySelectorAll(selector);

        for (const element of elements) {
          if (slot.contains(element)) continue;
          if (containsCheckout(element)) continue;

          const widget = promoteToCompleteContainer(element);
          if (widget) return widget;
        }
      }

      return null;
    };

    const decorateLabel = (widget) => {
      const elements = widget.querySelectorAll('label, h1, h2, h3, h4, p, span');

      for (const element of elements) {
        const value = (element.textContent || '').trim().replace(/\s+/g, ' ');
        if (value.length <= 140 && dateTextPattern.test(value)) {
          element.classList.add('dlm-delivery-date-label');
          return;
        }
      }
    };

    const isCompleteWidget = (widget) => {
      if (!widget || containsCheckout(widget) || isBroadThemeContainer(widget)) return false;
      if (!hasDateControl(widget) || !hasDateIdentity(widget)) return false;

      const text = (widget.textContent || '').trim().replace(/\s+/g, ' ');
      return text.length > 0;
    };

    const setSlotState = (slot, ready) => {
      slot.hidden = !ready;
      slot.classList.toggle('is-ready', ready);
    };

    const placeDeliveryDate = () => {
      const slot = document.querySelector(slotSelector);
      if (!slot) return;

      const mounted = slot.querySelector('.dlm-delivery-date-widget');
      if (mounted) {
        setSlotState(slot, isCompleteWidget(mounted));
        return;
      }

      setSlotState(slot, false);

      const widget = findByAppMarkers(slot) || findByLabelText(slot);
      if (!isCompleteWidget(widget)) return;

      widget.classList.add('dlm-delivery-date-widget');
      decorateLabel(widget);
      slot.appendChild(widget);
      setSlotState(slot, isCompleteWidget(widget));
    };

    const schedulePlacement = () => {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        placeDeliveryDate();
      });
    };

    const start = () => {
      schedulePlacement();

      const observer = new MutationObserver(schedulePlacement);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true });

      document.addEventListener('shopify:section:load', schedulePlacement);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
